// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.FiltersDisplay_filterTag__MrZP7 {\n  color: #595959;\n  display: inline-flex;\n  align-items: center;\n  background: white;\n  transform: rotate(180deg);\n  border-color: #999999; }\n  .FiltersDisplay_filterTag__MrZP7 .anticon {\n    color: #222222;\n    margin-right: 0;\n    margin-left: 5px; }\n\n.FiltersDisplay_wrapper__2jV6s {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  transform: rotate(180deg);\n  position: relative;\n  top: 4px; }\n  .FiltersDisplay_wrapper__2jV6s > * {\n    margin: 4px 8px; }\n", ""]);
// Exports
exports.locals = {
	"filterTag": "FiltersDisplay_filterTag__MrZP7",
	"wrapper": "FiltersDisplay_wrapper__2jV6s"
};
module.exports = exports;
